/**
 * Diálogo de exclusão que checa vínculos antes de confirmar.
 *
 * `window.confirm` não aceita conteúdo, então a confirmação e o bloqueio por vínculo dividem
 * o mesmo Dialog: enquanto a checagem de dependências está em voo mostra um spinner, e o
 * corpo final é o PrerequisiteBlock (bloqueado) ou a confirmação simples (livre). As telas de
 * risco ocupacional, fonte geradora, exame ocupacional, EPI e EPC repetiam esse JSX idêntico;
 * só os textos e a permissão/rota do PrerequisiteBlock mudavam.
 */
import React from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PrerequisiteBlock, type PrerequisiteBlockProps } from './PrerequisiteBlock';

export interface DeleteWithDependenciesDialogProps {
  open: boolean;
  loading: boolean;
  blocked: boolean;
  title: string;
  confirmText: string;
  prerequisite: Omit<PrerequisiteBlockProps, 'outOfScope'>;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteWithDependenciesDialog: React.FC<DeleteWithDependenciesDialogProps> = ({
  open,
  loading,
  blocked,
  title,
  confirmText,
  prerequisite,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      ) : blocked ? (
        <PrerequisiteBlock {...prerequisite} />
      ) : (
        <Typography>{confirmText}</Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
      {!loading && !blocked && (
        <Button onClick={onConfirm} color="error" variant="contained">
          Excluir
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

export default DeleteWithDependenciesDialog;
